/**
 * React Context для глобального хранения параметров контактной информации
 * Все компоненты могут подписываться на изменения через useContactParams()
 */

import React, { createContext, useContext, useState, useEffect } from 'react';
import { getContactParams } from '../utils/contactParams.js';

const ContactParamsContext = createContext(null);

/**
 * Provider для контактных параметров
 * Парсит параметры из URL при монтировании и при изменении hash
 */
export function ContactParamsProvider({ children }) {
  const [contactParams, setContactParams] = useState(() => {
    // Инициализируем при первом рендере
    const params = getContactParams();
    console.log('[ContactParamsProvider] Initial contact params:', params);
    return params;
  });

  useEffect(() => {
    // Обработчик изменения hash (для HashRouter)
    const handleHashChange = () => {
      const params = getContactParams();
      console.log('[ContactParamsProvider] Hash changed, updating contact params:', params);
      setContactParams(params);
    };

    // Слушаем изменения hash
    window.addEventListener('hashchange', handleHashChange);

    // Также проверяем при монтировании (может быть уже в нужном роуте)
    handleHashChange();

    return () => {
      window.removeEventListener('hashchange', handleHashChange);
    };
  }, []);

  return (
    <ContactParamsContext.Provider value={contactParams}>
      {children}
    </ContactParamsContext.Provider>
  );
}

/**
 * Hook для доступа к контактным параметрам
 * @returns {Object} Объект с контактными параметрами из URL
 */
export function useContactParams() {
  const context = useContext(ContactParamsContext);
  if (context === null) {
    throw new Error('useContactParams must be used within ContactParamsProvider');
  }
  return context;
}
